import React, { useState } from "react"
import { Button, Card, CardBody, Collapse } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"
import CSAlert from "components/Alert/ConfirmationAlert"
import AdjustmentActionRequestFilters from "./AdjustmentActionRequestFilters"
import { useDispatch, useSelector } from "react-redux"
import { ProvActionRequestAction } from "store/provider-action-requests/provider-action-request-slice"
import { downloadURL } from "api/APP_URL"

const AdjustmentActionRequestListComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onAllDeleteClicked,
  onAdvancedSearchSubmit,
  onClickDetail,
  onCancelDeleteClicked,
}) => {
  const navigate = useNavigate()
  const [filterOpen, setFilterOpen] = useState(false)

  const actionIds = useSelector(state => state.provActionRequests.ids)
  const dispatch = useDispatch()

  // Store record in ProvAction Dispatch when a checkbox is clicked
  const onCheckboxClick = (e, id) => {
    const check = actionIds.includes(id)
    if (check) {
      const updated = actionIds.filter(myId => myId !== id)
      dispatch(ProvActionRequestAction.setIds(updated))
    } else {
      dispatch(ProvActionRequestAction.setNewIds(id))
    }
  }

  // Handle bulk deletion when top delete button is clicked and confirmed
  const onAllDeleteHandler = async () => {
    const results = await CSAlert({
      title: "Are you sure delete?",
    })
    if (results.isConfirmed) {
      onAllDeleteClicked(actionIds)
    }
  }

  // Handle cancel action when cancel button is clicked and confirmed
  const onCancelDeleteHandler = async () => {
    const results = await CSAlert({
      title: "Are you sure for cancel?",
    })
    if (results.isConfirmed) {
      onCancelDeleteClicked(actionIds)
    }
  }

  // Handle parent checkbox status change to select/deselect all items
  const onParentCheckChange = status => {
    if (status) {
      const all = data?.data.map(dt => dt.id)
      dispatch(ProvActionRequestAction.setIds(all))
    } else {
      dispatch(ProvActionRequestAction.resetIds())
    }
  }

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CustomHeaderTitle
            loading={loading}
            title={"List"}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={true}
            onChangeOrdering={onChangeOrdering}
            searchBox={false}
            onSearchHandler={onSearch}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "created_at", name: "Created" },
            ]}
          />

          <Collapse isOpen={filterOpen}>
            <AdjustmentActionRequestFilters
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>

          <div className="d-flex justify-content-end mb-3 gap-2">
            <Button
              color="danger"
              onClick={onAllDeleteHandler}
              disabled={loading}
            >
              <i className="bx bx-trash font-size-16 align-middle me-2"></i>
              Delete
            </Button>
            <Button
              color="warning"
              onClick={onCancelDeleteHandler}
              disabled={loading}
            >
              <i className="bx bx-x font-size-16 align-middle me-2"></i>
              Cancel
            </Button>
          </div>

          <GeneralTables
            data={data?.data}
            loading={loading}
            parentCheckbox={true}
            onParentCheckChange={onParentCheckChange}
            headers={[
              "SN",
              "PROVIDER",
              "ITEM CATEGORY",
              "ITEM",
              "TYPE",
              "QTY",
              "REASON",
              "DATE",
              "Action",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(row, index) => (
              <tr key={index}>
                <th scope="row">
                  <div className="form-check form-checkbox-outline form-check-primary mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`checkbox-${row.id}`}
                      checked={actionIds.includes(row.id)}
                      onChange={e => onCheckboxClick(e, row.id)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`checkbox-${row.id}`}
                    >
                      {data?.meta?.from + index}
                    </label>
                  </div>
                </th>
                <td>{row?.user?.name}</td>
                <td>{row?.item_category?.name}</td>
                <td>{row?.item?.item_name}</td>
                <td>{row?.adjustment_type}</td>
                <td>{row?.qty}</td>
                <td>{row?.reason}</td>
                <td>{row?.date}</td>
                <td>
                  <ActionColumns
                    data={row}
                    enableEdit={false}
                    enableDelete={false}
                    enableDetail={true}
                    onClickDetail={onClickDetail}
                    enableDocumentLink={row?.document}
                    documentLink={`${downloadURL}/${row?.document}`}
                  />
                </td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default AdjustmentActionRequestListComponent
